<template>
  <section
    class="Home-Wrapper h-screen w-full bg-image px-10 flex flex-col justify-start balance-padding"
    :style="{ '--home-bg': 'url(' + homeBgURL + ')' }"
  >
    <div class="text-white text-12px w-auto md:text-20px md:mt-10 lg:mt-20 ">
      <div class="tracking-2.4px">{{ $t('main_screen.small_header') }}</div>
      <div
        class="text-white text-40px md:text-50px font-bold pt-8 font-Foco lg:mt-20"
      >
        <div class="spacing md:leading-70px whitespace-pre-line">
          {{ $t('main_screen.big_header').replace('-', '&#8209;') }}
        </div>
      </div>
    </div>
    <div
      v-if="shouldShowAppStoreLinks()"
      class="flex mt-10 sm:mt-16 mdplus:mt-32 lg:mt-48 justify-between md:justify-start lg:justify-center"
    >
      <a class="but md:w-1/3 float-right" :href="appStoreLinks.ios">
        <img class="inline" src="~@/assets/apple-app-store-btn-EN.svg" />
      </a>
      <a
        class="but md:h-16 lg:h-24 md:w-1/3 md:ml-12 lg:-ml-20"
        :href="appStoreLinks.android"
      >
        <img class="inline" src="~@/assets/google-play-store-btn-EN.svg" />
      </a>
    </div>
    <div
      v-if="shouldShowPopup"
      id="btn-popup"
      class="lg:w-1/3 mt-auto mb-16 md:mb-20"
      v-on:click="isModalVisible = true"
    >
      <div v-if="matchEntities(['NETHERLANDS'])" class="ExternalFormCTA">
        <div
          class="md:text-20px PilotText px-8 py-3 text-sm tracking-0.24px md:tracking-0.4px font-bold text-right md:mt-2"
        >
          {{ $t('main_screen.pilot_btn_top') }}
        </div>
      </div>
      <div
        v-else
        class="btn-parent w-full md:w-420px md:h-95px rounded-58px rounded-full border-solid border border-qwellow lg:mt-0 p-1 shadow-md btn-gradient inline-flex cursor-pointer"
      >
        <div class="flex-row w-4/5 py-1 text-white">
          <div
            class="md:text-20px AlignText text-12px tracking-0.4px md:tracking-0.4px font-bold text-right md:mt-2"
          >
            {{ $t('main_screen.pilot_btn_top') }}
          </div>
        </div>
        <div class="flex w-1/5 justify-end">
          <img src="~@/assets/arrow.svg" class=" self-center mr-8 h-6 md:h-8" />
        </div>
      </div>
    </div>
    <div class="w-auto" v-if="isModalVisible">
      <PopupDE v-if="entity === 'GERMANY'" v-on:modalClose="onModalClose" />
      <PopupNL v-if="entity === 'NETHERLANDS'" v-on:modalClose="onModalClose" />

      <popup-stations v-else v-on:modalClose="onModalClose" />
    </div>
  </section>
</template>

<script>
import hasPopupQuery from '@/shared/homePagePopupChecker';
import PopupStations from './PopupStations.vue';
import PopupDE from './PopupDE.vue';
import PopupNL from './PopupNL.vue';
import { entity } from '../../../../region.json';
import appStoreLinks from '../../../data/appStoreLinks';
import matchEntities, {
  allowPopup,
  shouldShowAppStoreLinks,
} from '../../../shared/entityHelpers';

export default {
  components: {
    PopupStations,
    PopupDE,
    PopupNL,
  },
  data() {
    return {
      isModalVisible: false,
      appStoreLinks,
      entity,
      homeBgURL: matchEntities(['POLAND', 'NETHERLANDS'])
        ? // eslint-disable-next-line global-require
          require('@/assets/home-bg-POLAND.jpg')
        : // eslint-disable-next-line global-require
          require('@/assets/home-bg-mobile.jpg'),
    };
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onModalClose() {
      this.closeModal();
    },
    matchEntities,
    shouldShowAppStoreLinks,
  },
  computed: {
    isMobile() {
      // eslint-disable-next-line
      return screen.width < 768;
    },
    shouldShowPopup() {
      return allowPopup();
    },
  },
  mounted() {
    if (
      (this.shouldShowPopup && hasPopupQuery(this.$router)) ||
      matchEntities(['NETHERLANDS'])
    ) {
      this.isModalVisible = true;
    }
  },
};
</script>

<style scoped>
.ExternalFormCTA {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--qwellow);
  color: var(--qwray);
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #ffdf22;
  border-radius: 99px;
}
.ExternalFormCTA[margin] {
  margin-bottom: 4em;
}

.PilotText {
  font-size: 16px;
  margin-top: 0;
}
.bg-image {
  background: var(--home-bg) center center no-repeat;
  background-size: cover;
}
.btn-gradient {
  background-image: linear-gradient(
    rgba(255, 223, 34, 0.1),
    rgba(255, 223, 34, 0.3)
  );
}
.but {
  width: 45%;
}
.balance-padding {
  padding-top: 26%;
}
.spacing {
  line-height: 50px;
}
.btn-parent {
  height: 50px;
}
@media (max-width: 380px) {
  .Home-Wrapper {
    height: calc(100vh + 50px);
  }
}
@media (max-width: 420px) {
  .AlignText {
    max-width: 90%;
    margin-left: auto;
    text-align: left;
    padding-right: 0.5rem;
    display: grid;
    place-items: center;
    text-align: left;
    height: 100%;
  }
}
</style>
